import { render, staticRenderFns } from "./CourseBuilderPodcastForm.vue?vue&type=template&id=21603626&scoped=true&"
import script from "./CourseBuilderPodcastForm.vue?vue&type=script&lang=js&"
export * from "./CourseBuilderPodcastForm.vue?vue&type=script&lang=js&"
import style0 from "./CourseBuilderPodcastForm.vue?vue&type=style&index=0&id=21603626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21603626",
  null
  
)

export default component.exports